/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-05 12:52:11                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-10 15:40:40                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
*/

/* Imports */
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
/***/

/* Components */
import { Table } from "../../../components/table/Table";
import WorkorderListItem from "../../../components/data/workorder/WorkorderListItem";
/***/

import { t } from "../../../i18n";

export function WorkordersTable({
  workorders,
  selectedHead,
  orderDesc,
  onHeadClick,
  onChange,
  isAdminComponent,
  customer,
  showTypeColumn = true,
  showOriginColumn = true
}: {
  workorders: EasyTech.Workorder[],
  selectedHead?: string,
  orderDesc?: boolean,
  onHeadClick?: (head: string, orderDesc: boolean) => void,
  onChange?: () => void,
  isAdminComponent?: boolean,
  customer?: EasyTech.Customer,
  showTypeColumn?: boolean,
  showOriginColumn?: boolean
}) {
  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1440);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth <= 1440);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const TABLE_HEAD: ({
    label: string,
    orderKey: string | null,
    width: string,
    headClassName?: string
  }[]) = [
    {
      label: t("common:ref:label"),
      orderKey: "ref",
      width: "10%"
    }
  ];
  
  if (customer === undefined)
    TABLE_HEAD.push({
      label: t("common:customer"),
      orderKey: "customer.name",
      width: "15%"
    });
    
  TABLE_HEAD.push({
    label: t("common:contact"),
    orderKey: null,
    width: "12%"
  });
  TABLE_HEAD.push({
    label: t("common:technician"),
    orderKey: "technician.user.lastName",
    width: "12%"
  });
  TABLE_HEAD.push({
    label: t("common:status"),
    orderKey: "status",
    width: isSmallScreen ? "80px" : "10%",
    headClassName: isSmallScreen ? "text-center" : ""
  });
  TABLE_HEAD.push({
    label: t("common:address"),
    orderKey: "address.address",
    width: isAdminComponent ? "15%" : "auto"
  });
  
  if (showTypeColumn) {
    TABLE_HEAD.push({
      label: t("common:type"),
      orderKey: "type",
      width: "10%"
    });
  }
  
  if (showOriginColumn) {
    TABLE_HEAD.push({
      label: t("common:origin"),
      orderKey: "origin",
      width: "10%"
    });
  }

  TABLE_HEAD.push({
    label: t("workorder:diag", "DIAG"),
    orderKey: "safetyDiagStatus",
    width: "80px",
    headClassName: "text-center"
  });

  if (isAdminComponent) TABLE_HEAD.push({label: t("common:actions"), orderKey: null, width: "10%" });

  return (
    <Table  tableHead={TABLE_HEAD} emptyTable={(!workorders || workorders.length === 0) ? t("common:noWorkorders") : false}
     selectedHead={selectedHead} orderDesc={orderDesc}
     onHeadClick={onHeadClick}
     enableRowLinks={true}>
      {workorders && workorders.map((workorder: EasyTech.Workorder, i: number) => (
          <WorkorderListItem  key={workorder.id}
                              workorder={workorder}
                              onClick={() => navigate(`/workorders/${workorder.id}`)}
                              isLast={i === workorders.length - 1}
                              onChange={() => { if (onChange) onChange();}}
                              customer={customer}
                              isAdminComponent={isAdminComponent === undefined ? false : isAdminComponent}
                              showTypeColumn={showTypeColumn}
                              showOriginColumn={showOriginColumn}
                              isSmallScreen={isSmallScreen} />
      ))}
    </Table>
  );
}
